module.exports = __webpack_public_path__ + "img/GDQ-matcirkel_50.23377a07.gif";